import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { useEffect, useState } from "react";
const CustomTooltip = ({
  selectedKPI,
  showDetail,
  tooltipRoom,
  noOfPeople,
  noOfEmptySeat,
  rooms,
}) => {
  // tooltipPattern && tooltipPattern !== 4 && (
  //   <div className="d-flex flex-column justify-content-start gap-2">
  //     <div className="mb-1">
  //       Area:{" "}
  //       {tooltipRoom === 4381
  //         ? "100"
  //         : tooltipRoom === 4382
  //         ? "200"
  //         : tooltipRoom === 4383
  //         ? "300"
  //         : tooltipRoom === 4384
  //         ? "250"
  //         : tooltipRoom === 5251
  //         ? "150"
  //         : tooltipRoom === 11
  //         ? "280"
  //         : tooltipRoom === 12
  //         ? "190"
  //         : tooltipRoom === 13
  //         ? "118"
  //         : tooltipRoom === 14
  //         ? "129"
  //         : "N/A"}{" "}
  //       m2
  //     </div>
  //     <div className="mb-1">
  //       Status:
  //       {tooltipPattern === 3 &&
  //       (tooltipRoom === 11 ||
  //         tooltipRoom === 12 ||
  //         tooltipRoom === 13 ||
  //         tooltipRoom === 14 ||
  //         tooltipRoom === 5259)
  //         ? ` Inactive`
  //         : ` Active`}
  //     </div>
  //     {/* Pattern Selected */}
  //     <div>
  //       <span>Pattern: </span>
  //       {tooltipPattern === 1 ? (
  //         <img
  //           src="/images/icons/productivity-selected.png"
  //           width={20}
  //           style={{ marginLeft: "8px" }}
  //         />
  //       ) : tooltipPattern === 2 ? (
  //         <img
  //           src="/images/icons/vaping-selected.png"
  //           width={20}
  //           style={{ marginLeft: "8px" }}
  //         />
  //       ) : tooltipPattern === 3 ? (
  //         <img
  //           src="/images/icons/efficiency-selected.png"
  //           width={20}
  //           style={{ marginRight: "8px" }}
  //         />
  //       ) : (
  //         "None"
  //       )}
  //     </div>
  //     {/* Problem */}
  //     <div>
  //       Problem:
  //       <span style={{ marginLeft: "10px", fontSize: "16px" }}>
  //         {/* Pattern 1 */}
  //         {tooltipPattern && tooltipPattern.problem?tooltipPattern.problem:'None'}
  //       </span>
  //     </div>
  //     {/* Recommendation */}
  //     <div className="d-flex flex-column">
  //       <div>Recommendation:</div>
  //       <span style={{ marginLeft: "10px", fontSize: "16px" }}>
  //          {tooltipPattern && tooltipPattern.recommendation?tooltipPattern.recommendation:'None'}
  //       </span>
  //     </div>
  //     <Button variant="success" width={50}>
  //       Send alert
  //     </Button>
  //   </div>

  const getNoOfPeopleByDirection = (roomID, noOfPeople, direction) => {
    const room = noOfPeople[roomID];
    if (room) {
      if (direction === "front") {
        return (room.NoP_front / room.count).toFixed(0);
      } else if (direction === "back") {
        return (room.NoP_back / room.count).toFixed(0);
      } else if (direction === "left") {
        return (room.NoP_left / room.count).toFixed(0);
      } else if (direction === "right") {
        return (room.NoP_right / room.count).toFixed(0);
      }
    }
    return "N/A";
  };

  const getNoOfEmptySeatByDirection = (roomID, noOfEmptySeat, direction) => {
    const room = noOfEmptySeat[roomID];
    if (room) {
      if (direction === "front") {
        return (room.NoES_front / room.count).toFixed(0);
      } else if (direction === "back") {
        return (room.NoES_back / room.count).toFixed(0);
      } else if (direction === "left") {
        return (room.NoES_left / room.count).toFixed(0);
      } else if (direction === "right") {
        return (room.NoES_right / room.count).toFixed(0);
      }
    }
    return "N/A";
  };

  const retrieveRoomDesc=(roomID,rooms, direction)=>{
    const room=rooms.find(room=>room.id===roomID);
    if(room){
      if(direction==="front"){
        return room.front_Desc;
      }else if(direction==="back"){
        return room.back_Desc;
      }else if(direction==="left"){
        return room.left_Desc;
      }else if(direction==="right"){
        return room.right_Desc;
      }
      return null;
    }

    return "N/A";
  }

  return (
    <>
      {showDetail && (
        <OverlayTrigger
          placement="top" // Show the tooltip straight up
          delay={{ show: 250, hide: 400 }}
        >
          {/* CustomTooltip content */}
          <div
            className="d-flex p-3 tooltip-content"
            style={{
              top: `${0}px`, // Use the y-coordinate of the tooltip position
              right: `${10}px`,
              zIndex: 1000,
              position: "absolute",
            }}
          >
            <div className="d-flex flex-column">
              {/* Room */}
              <Badge
                style={{
                  fontSize: "14px",
                  minWidth: "150px",
                  marginBottom: "10px",
                }}
                variant="success"
              >
                Room: {tooltipRoom.Room}
              </Badge>

              {/* Room Details - People by direction*/}
              {selectedKPI === 1 && (
                <>
                  <div
                    className="d-flex justify-content-between"
                    style={{ fontSize: "12px" }}
                  >
                    <div>
                      Front {retrieveRoomDesc(tooltipRoom.id,rooms,"front")? `(${retrieveRoomDesc(tooltipRoom.id,rooms,"front")})`:null}:{" "}
                      {getNoOfPeopleByDirection(
                        tooltipRoom.id,
                        noOfPeople,
                        "front"
                      )}
                    </div>
                    <div>
                      Right {retrieveRoomDesc(tooltipRoom.id,rooms,"right")? `(${retrieveRoomDesc(tooltipRoom.id,rooms,"right")})`:null}:{" "}
                      {getNoOfPeopleByDirection(
                        tooltipRoom.id,
                        noOfPeople,
                        "right"
                      )}
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-between"
                    style={{ fontSize: "12px" }}
                  >
                    <div>
                      Back {retrieveRoomDesc(tooltipRoom.id,rooms,"back")? `(${retrieveRoomDesc(tooltipRoom.id,rooms,"back")})`:null}:{" "}
                      {getNoOfPeopleByDirection(
                        tooltipRoom.id,
                        noOfPeople,
                        "back"
                      )}
                    </div>
                    <div>
                      Left {retrieveRoomDesc(tooltipRoom.id,rooms,"left")? `(${retrieveRoomDesc(tooltipRoom.id,rooms,"left")})`:null}:{" "}
                      {getNoOfPeopleByDirection(
                        tooltipRoom.id,
                        noOfPeople,
                        "left"
                      )}
                    </div>
                  </div>
                </>
              )}

              {/* Room Details - Empty Seat by direction*/}
              {selectedKPI === 2 && (
                <>
                  <div
                    className="d-flex justify-content-between"
                    style={{ fontSize: "12px" }}
                  >
                    <div>
                      Front {retrieveRoomDesc(tooltipRoom.id,rooms,"front")? `(${retrieveRoomDesc(tooltipRoom.id,rooms,"front")})`:null}:{" "}
                      {getNoOfEmptySeatByDirection(
                        tooltipRoom.id,
                        noOfEmptySeat,
                        "front"
                      )}
                    </div>
                    <div>
                      Right {retrieveRoomDesc(tooltipRoom.id,rooms,"right")? `(${retrieveRoomDesc(tooltipRoom.id,rooms,"right")})`:null}:{" "}
                      {getNoOfEmptySeatByDirection(
                        tooltipRoom.id,
                        noOfEmptySeat,
                        "right"
                      )}
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-between"
                    style={{ fontSize: "12px" }}
                  >
                    <div>
                      Back {retrieveRoomDesc(tooltipRoom.id,rooms,"back")? `(${retrieveRoomDesc(tooltipRoom.id,rooms,"back")})`:null}:{" "}
                      {getNoOfEmptySeatByDirection(
                        tooltipRoom.id,
                        noOfEmptySeat,
                        "back"
                      )}
                    </div>
                    <div>
                      Left {retrieveRoomDesc(tooltipRoom.id,rooms,"left")? `(${retrieveRoomDesc(tooltipRoom.id,rooms,"left")})`:null}:{" "}
                      {getNoOfEmptySeatByDirection(
                        tooltipRoom.id,
                        noOfEmptySeat,
                        "left"
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </OverlayTrigger>
      )}
    </>
  );
};

export default CustomTooltip;
